import { html, LitElement, css, unsafeCSS } from 'lit';
import styles from './list.scss?inline';

export default class SotbitList extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    constructor() {
        super();
    }

    render() {
        return html`
            <div class="container">
                <slot name="header"></slot>

                <slot name="items"></slot>
            </div>
        `;
    }
}
